import classnames from 'classnames';
import React from 'react';
import styles from './styles.module.scss';

const Button = ({
  className,
  disabled,
  title,
  type = 'primary',
  onClick
}) => {
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: classnames(styles.container, type === 'secondary' && styles.secondary, className),
    disabled: disabled
  }, /*#__PURE__*/React.createElement("span", null, title));
};

export default Button;